import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import { useCallback, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Space, Form } from 'antd';
import { TextLinkButton, NumberInput, TransparentButton, SingleSelectInput } from '@lib/common';
import { DeleteOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { RichTextEditor } from '../rich-text-editor';
import { questionTypeOptions } from './index';
import { QuestionType } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 32px 40px;\n  border-radius: 8px;\n  background: ", ";\n  margin-bottom: 16px;\n  overflow: hidden;\n  border: 1px solid ", ";\n"])), styleVariables.colors.gray1, styleVariables.colors.blue4);
var Content = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  .ant-form-item {\n    margin-bottom: 4px;\n    margin-top: 4px;\n  }\n  .ant-typography {\n    margin-bottom: 0;\n  }\n"])));
var ExplanationField = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var QuestionHeaderContainer = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n"])));
var QuestionHeader = styled(Space)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var QuestionHeaderTitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 20px;\n  font-weight: 600;\n"])));
var QuestionContentTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n"])));
var QuestionContentContainer = styled(Space)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: inherit;\n"])));
export var BaseQuestionEdit = function BaseQuestionEdit(props) {
  var index = props.index,
      onDeleteQuestion = props.onDeleteQuestion,
      children = props.children,
      type = props.type;

  var _useState = useState(false),
      isDisplayExplain = _useState[0],
      setIsDisplayExplain = _useState[1];

  var isFillInBlank = type === QuestionType.FillInBlank;
  var onDisplayExplain = useCallback(function () {
    setIsDisplayExplain(!isDisplayExplain);
  }, [isDisplayExplain]);
  var generateExplainField = useCallback(function () {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TransparentButton, {
        size: "middle",
        icon: !isDisplayExplain ? /*#__PURE__*/_jsx(PlusOutlined, {}) : /*#__PURE__*/_jsx(MinusOutlined, {}),
        onClick: onDisplayExplain,
        children: "Th\xEAm gi\u1EA3i th\xEDch"
      }), isDisplayExplain && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "Gi\u1EA3i th\xEDch "
        }), /*#__PURE__*/_jsx(ExplanationField, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: 'explanation',
            children: /*#__PURE__*/_jsx(RichTextEditor, {
              id: "question-explanation-".concat(index),
              shouldAutoFocus: true
            })
          })
        })]
      })]
    });
  }, [index, isDisplayExplain, onDisplayExplain]);
  return /*#__PURE__*/_jsxs(Container, {
    direction: "vertical",
    id: "q_".concat(index),
    children: [/*#__PURE__*/_jsxs(QuestionHeaderContainer, {
      children: [/*#__PURE__*/_jsxs(QuestionHeader, {
        children: [/*#__PURE__*/_jsxs(QuestionHeaderTitle, {
          children: ["C\xE2u ", index + 1]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: 'type',
          children: /*#__PURE__*/_jsx(SingleSelectInput, {
            options: questionTypeOptions,
            defaultValue: [type]
          })
        })]
      }), /*#__PURE__*/_jsxs(QuestionHeader, {
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: 'score',
          children: /*#__PURE__*/_jsx(NumberInput, {
            max: 10,
            min: 0,
            step: "0.25",
            controls: true,
            addonAfter: "\u0111i\u1EC3m",
            disabled: isFillInBlank,
            stringMode: true
          })
        }), /*#__PURE__*/_jsx(TextLinkButton, {
          onClick: onDeleteQuestion,
          icon: /*#__PURE__*/_jsx(DeleteOutlined, {})
        })]
      })]
    }), /*#__PURE__*/_jsxs(Content, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "C\xE2u h\u1ECFi "
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: 'description',
          children: /*#__PURE__*/_jsx(RichTextEditor, {
            id: "question-description-".concat(index),
            shouldAutoFocus: true
          })
        })]
      }), children, generateExplainField()]
    })]
  });
};